import { Alert } from '@design/components/alert/Alert';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useUserUpload } from '../use-user-upload/useUserUpload';
import styles from './UploadAlert.module.scss';

interface UploadAlertProps {
  onViewDetails: () => void;
}

export const UploadAlert = ({ onViewDetails }: UploadAlertProps) => {
  const { t } = useTranslation(['chat']);

  const {
    alertOpen,
    errorFiles,
    completeFiles,
    errorMessage,
    initializeAlert,
  } = useUserUpload(state => ({
    alertOpen: state.alertOpen,
    errorFiles: state.files.filter(f => f.status === 'error'),
    completeFiles: state.files.filter(f => f.status === 'complete'),
    errorMessage: state.errorMessage,
    initializeAlert: state.initializeAlert,
  }));

  const title = (() => {
    if (errorMessage) {
      return errorMessage;
    }

    if (errorFiles.length === 1) {
      return t('chat:uploadAlert.singleFileError', {
        errorMessage: errorFiles[0].errorMessage,
      });
    }

    return t('chat:uploadAlert.failedToUploadWithCount', {
      count: errorFiles.length,
    });
  })();

  return (
    alertOpen && (
      <Alert
        className={styles.alert}
        title={title}
        onClose={initializeAlert}
        primaryBtn={
          completeFiles.length
            ? {
                label: t('chat:uploadAlert.viewDetails'),
                onClick: () => {
                  onViewDetails();
                  initializeAlert();
                },
              }
            : undefined
        }
        data-testid="upload-alert"
      />
    )
  );
};
